import React, {useState} from "react";
import { Link, Redirect, Router } from "@reach/router";
import Header from "../Components/Header.jsx";
import Explore from "../Pages/Explore.js"


const Login = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loggedIn, setLoggedIn] = useState(false)
  const onSubmit = (e) => {
    // ReactSession.set("username", username);
    // ReactSession.set("userId", ReactSession.get("userId") + 1);
    // setLoggedIn(true)
  }
  return(
  <div>
  {loggedIn ? <Redirect to="/" /> : <div>
      <form onSubmit={onSubmit}>
      <Header />
      User:
      <textarea value={username} onChange={e => setUsername(e.target.value)}></textarea>
      Password:
      <textarea value={password} onChange={e => setPassword(e.target.value)}></textarea>
      <button>LOGIN</button>
      </form>
    </div>}
</div>
  )
};

export default Login;
